import axios from "axios";

const getRewards = (payload) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    const response = await axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}/api/v1//campaign/${payload.campaignId}/reward-groups`
      )
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        dispatch({
          type: "SET_REWARD_GROUPS",
          payload: response.data.data,
        });
        if (payload.cb) {
          payload.cb();
        }
      }
    }
  };
};

const getReward = (payload) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    const response = await axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}/api/v1/campaign/${payload.campaignId}/reward-groups/${payload.rewardgroupId}`
      )
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        var redemptionCodes = "";
        redemptionCodes = response.data.data.rewards
          .filter((obj) => !!obj.redemptionCode)
          .map((obj) => obj.redemptionCode)
          .join(",");
        response.data.data.redemptionCodes = redemptionCodes;
        dispatch({
          type: "SET_REWARD",
          payload: response.data.data,
        });
        payload.cb();
      }
    }
  };
};

const updateRewardInfo = (payload) => {
  return {
    type: "SET_REWARD_INFO",
    payload,
  };
};

const updateReward = (payload) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    let data = store().rewards.reward;
    const response = await axios
      .put(
        `${process.env.REACT_APP_API_ENDPOINT}/api/v1/campaign/${payload.campaignId}/reward-groups/${payload.rewardgroupId}`,
        {
          status: data.status
        }
      )
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "INFO",
          },
        });
        payload.cb();
      }
    }
  };
};

const createReward = (payload) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    let data = {
      ...store().rewards.reward
    }
    if (!data.redemptionCodes) {
      data.redemptionCodes = "";
    }
    console.log("abhishekk",data)
    if (
      data.redemptionCodes &&
      data.redemptionCodes.split(",").length != data.quantity
    ) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      dispatch({
        type: "SET_USER_MESSAGE",
        payload: {
          message:
            "Reward quantity is specified as: " +
            (data.quantity || 0) +
            " but you have provided " +
            data.redemptionCodes.split(",").length +
            " codes",
          type: "ERROR",
        },
      });
    } else {
      data.redemptionCodes = data.redemptionCodes ? data.redemptionCodes.split(",") : [];
      const response = await axios
        .post(
          `${process.env.REACT_APP_API_ENDPOINT}/api/v1/campaign/${payload.campaignId}/reward-group`,
          data
        )
        .catch((e) => {
          dispatch({
            type: "TOGGLE_LOADING",
          });
        });
      if (response && response.data) {
        dispatch({
          type: "TOGGLE_LOADING",
        });
        if (!response.data.success) {
          dispatch({
            type: "SET_USER_MESSAGE",
            payload: {
              message: response.data.message,
              type: "ERROR",
            },
          });
        } else {
          dispatch({
            type: "SET_USER_MESSAGE",
            payload: {
              message: response.data.message,
              type: "INFO",
            },
          });
          payload.cb();
        }
      }
    }
  };
};

const resetReward = () => {
  return {
    type: "RESET_REWARD",
  };
};

const getRedeemRewardInfo = (brand_slug, reward_id, consumer_id) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    const response = await axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}/api/v1/brand/${brand_slug}/reward/${reward_id}/user/${consumer_id}/redeem/info`
      )
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      if (response.data.success){
        dispatch({
          type: "TOGGLE_LOADING",
        });
        dispatch({
          type: "SET_REDEEM_REWARD_INFO",
          payload: response.data.data,
        });
      } else {
        dispatch({
          type: "TOGGLE_LOADING",
        });
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      }
    }
  };
};


const postRewardDetails = (payload) => {
  let data = JSON.stringify(payload);
  return async (dispatch, store) => {
    dispatch({
      type: "TOGGLE_LOADING",
    });
    const response = await axios
      .post(`${process.env.REACT_APP_API_ENDPOINT}/api/v1/reward/redeem`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "INFO",
          },
        });
        dispatch({
          type: "SET_REWARD_CODE",
          payload: response.data.data,
        });
      }
    }
  };
};

export default {
  getRewards,
  updateRewardInfo,
  createReward,
  getReward,
  resetReward,
  updateReward,
  getRedeemRewardInfo,
  postRewardDetails
};
